import { ReactNode } from 'react'
import { useUnavailableProductDetailSection } from './productDetailVariants/useUnavailableProductDetailSection'
import { useCustomProductDetailSection } from './productDetailVariants/useCustomProductDetailSection/useCustomProductDetailSection'
import { useStockProductDetailSection } from './productDetailVariants/useStockProductDetailSection'
import { useComingSoonProductDetailSection } from './productDetailVariants/useComingSoonProductDetailSection/useComingSoonProductDetailSection'
import { usePlusProductDetailSection } from './productDetailVariants/usePlusProductDetailsSection/usePlusProductDetailSection'
import { THubspotFormSpecification } from 'app/(auth)/sign-up/profile/_types/hubspotForm'
import { ProductVariant } from '@pageFeatures/design/designUpload/types'
import { IProductEntry } from 'app/_services/CMS/contentful/types/productEntry'
export type TProductDetailSections = {
  priceSection: ReactNode
  mainSection: ReactNode
}

export type TPageState = 'unavailable' | 'coming-soon' | 'available'
export type TPageVariant = 'custom' | 'stock' | 'plus'

export function useProductPageVariation({
  pageState,
  pageVariant,
  hubspotPlusForm,
  productVariantsSales,
  productData,
}: {
  pageState: TPageState
  pageVariant: TPageVariant
  hubspotPlusForm: THubspotFormSpecification
  productVariantsSales: ProductVariant[]
  productData: IProductEntry
}): TProductDetailSections {
  if (pageState === 'unavailable') {
    return useUnavailableProductDetailSection()
  } else if (pageState === 'coming-soon') {
    return useComingSoonProductDetailSection(productData.productSlug)
  } else {
    switch (pageVariant) {
      case 'custom':
        return useCustomProductDetailSection({
          productVariants: productVariantsSales,
          productData,
        })
      case 'stock':
        return useStockProductDetailSection({
          productVariants: productVariantsSales,
          productData,
        })
      case 'plus':
        return usePlusProductDetailSection({ hubspotPlusForm, productData })
      default:
        return { priceSection: null, mainSection: null }
    }
  }
}
